export default {
    organization: 'Grupo de trabalho',
    project: 'Projeto',
    dataset: 'Conjunto de dados',
    report: 'Relatório',
    visualization: 'Visualização',
    download: 'Descarregar zip',
    events: 'Eventos',
    processing: 'Processando...',

    date: 'Data e hora',
    createdAt: 'Criado em',
    updateDate: 'Última atualização',
    projectCount: 'Projetos contidos',
    datasetCount: 'Conjuntos de dados contidos',
    deleteDate: 'Apagar em',
    startAt: 'Início em',
    endAt: 'Fim em',
    seenAt: 'Visto em',
    content: 'Conteúdo',

    code: 'Código',
    title: 'Título',
    name: 'Nome do atributo',
    description: 'Descrição do ficheiro',
    status: 'Estado',
    model: 'Modelo',
    email: 'Correio eletrónico',
    amount: 'Quantidade',
    actions: 'Acções',
    type: 'Tipo de alerta',
    file: 'Ficheiro',
    characters: 'caracteres',

    owner: 'Proprietário',
    sortBy: 'Ordenar por',
    sortDirection: 'Direção',
    ascending: 'Ascendente',
    descending: 'Descendente',

    readOnly: 'Só de leitura',
    archived: 'Arquivado',
    optional: 'Opcional',
    uploadData: 'Carregar dados',
    comingSoon: 'Em breve',

    account: 'Conta',
    profile: 'Perfil',
    apis: 'Token API',
    signout: 'Sair',

    back: 'Voltar',
    forward: 'Avançar',

    zoomIn: 'Ampliar',
    zoomOut: 'Reduzir',

    info: 'Informação',
    updateData: 'Atualizar dados',
    replaceData: 'Substituir dados',
    dataOptions: 'Opções de dados',

    filters: 'Filtros',
    sorting: 'Ordenação',
}
